import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles, BookOpen, Music, Heart, Wind, Droplets, ClipboardCheck } from 'lucide-react';
export function BonusGrid() {
  const bonuses = [{
    id: 1,
    title: 'Aromaterapia',
    description: 'Aceites esenciales para equilibrar tus emociones, elevar tu energía y transformar tu bienestar.',
    image: 'https://cdn.magicpatterns.com/uploads/pxE16WJQc4A1zSscGG43qC/bonus_1_aromaterapia.webp',
    tag: 'BONUS 1'
  }, {
    id: 2,
    title: 'Baños, Sahumerios y Limpiezas',
    description: 'Rituales poderosos para liberar lo que ya no te suma, elevar tu vibración y renovar tu energía.',
    image: 'https://cdn.magicpatterns.com/uploads/eGZpQHJj641q8sw41Ftt23/bonus_2_sahumerios.webp',
    tag: 'BONUS 2'
  }, {
    id: 3,
    title: 'Audios de Liberación',
    description: 'Meditaciones guiadas para acompañarte en tu proceso de transformación y sanación profunda.',
    image: 'https://cdn.magicpatterns.com/uploads/kshVbuq3WjER2WQSuicMx2/Bonus_3_audios.webp',
    tag: 'BONUS 3'
  }, {
    id: 4,
    title: 'Tablas + Check List',
    description: 'Herramientas prácticas para organizar, guiar y potenciar tu camino de transformación personal.',
    image: 'https://cdn.magicpatterns.com/uploads/p6xt3LT9QkRkqXo8VqkCZU/Bonus_4_Tablas2BCheck.webp',
    tag: 'BONUS 4'
  }];
  return <section className="py-24 px-4 relative overflow-hidden bg-[#2C2541] pt-[0px] pb-[0px]" data-id="element-47">
      <div className="max-w-7xl mx-auto" data-id="element-48">
        <div className="text-center mb-16" data-id="element-49">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#D9B15F]/10 border border-[#D9B15F]/30 text-[#D9B15F] text-sm font-medium mb-6" data-id="element-50">
            <Gift className="w-4 h-4" data-id="element-51" />
            <span data-id="element-52">Regalos exclusivos para vos</span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-6xl font-serif font-bold text-[#D9B15F] mb-6" data-id="element-53">
            Además, recibís estos 4 bonos especiales
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-[#B99BE8] max-w-2xl mx-auto" data-id="element-54">
            Para acompañarte aún más en este proceso, también vas a recibir
            materiales complementarios incluidos sin costo adicional.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 gap-6 max-w-md mx-auto" data-id="element-55">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="relative group rounded-2xl bg-[#3A3158]/40 border border-[#D9B15F]/10 hover:border-[#D9B15F]/30 transition-all duration-500 flex flex-col items-center text-center overflow-hidden" data-id="element-56">
              <div className="absolute top-2 left-1/2 -translate-x-1/2 px-2 py-0.5 rounded-full bg-[#D9B15F] text-[#2C2541] text-[8px] font-bold tracking-widest z-10 shadow-lg" data-id="element-57">
                {bonus.tag}
              </div>

              <div className="relative w-full overflow-hidden shadow-xl" data-id="element-58">
                <img src={bonus.image} alt={bonus.title} className="w-full h-auto block group-hover:scale-105 transition-transform duration-500" data-id="element-59" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2C2541]/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-60" />
              </div>

              <div className="p-4 flex flex-col items-center flex-grow w-full" data-id="element-61">
                <h3 className="text-base font-bold text-[#F8F5F2] mb-1 leading-tight" data-id="element-62">
                  {bonus.title}
                </h3>

                <p className="text-[#B99BE8] text-xs leading-relaxed flex-grow" data-id="element-63">
                  {bonus.description}
                </p>

                <div className="mt-3 pt-2 border-t border-[#D9B15F]/10 w-full" data-id="element-64">
                  <span className="text-[#D9B15F] font-bold text-[10px] uppercase tracking-widest" data-id="element-65">
                    Gratis
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}